import { render, staticRenderFns } from "./CardRoleView.vue?vue&type=template&id=c4d6a2ac&scoped=true"
import script from "./CardRoleView.vue?vue&type=script&lang=js"
export * from "./CardRoleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d6a2ac",
  null
  
)

export default component.exports